<div class="row">
	<div class="col-6">
		<div class="d-flex eip-p-0">
			<button class="btn btn-primary eip-ml-10 mr-2" id="btnAdd" (click)="addItems()">Move</button>
		</div>
		<mat-selection-list disableRipple="true">
			<mat-list-option disableRipple="true" color="primary" checkboxPosition="before"
				*ngFor="let item of allItems" [value]="item">
				{{item[textField]}}
			</mat-list-option>
		</mat-selection-list>
	</div>
	<div class="col-6">
		<div cdkDropList class="example-list" (cdkDropListDropped)="drop($event)">
			<div class="example-box" *ngFor="let item of selectedItems" cdkDrag>
				<div class="example-custom-placeholder" *cdkDragPlaceholder></div>
				{{item[textField]}}
			</div>
		</div>
	</div>
</div>
<div mat-dialog-title>
	<div class="d-flex justify-content-between">
	  Employee Cart
	  <i class="fa fa-times-circle pull-right"  aria-hidden="true"></i>
	</div>
  </div>
  <div mat-dialog-content>
	<div class="row reset-row">
	  <div class="col-md-12 eip-pb-10">
		<div class="container material-cart-container">
		  <div class="row main">
			<div class="material-list-right col-md-6 cart-border">
			  <div class="material-cart">
				<div class="material-cart-box">
				  <div class="row">
					<div class="col-md-12">
					  <p class="ff-2 fs-14">Choose Items</p>
					</div>
					<div class="col-md-10">
					  <EIPAutoComplete TextField="dedDescription" floatLabelOption="never" WaterMarkText="Search">
					  </EIPAutoComplete>
					</div>
					<div class="col-md-2 align-self-center p-0 cart-left">
					  <div class="btn-group">
						<a class="btn btn-default job-selector" title="select all"><i
							class="fa fa-angle-double-right font-weight-bold"></i></a>
						<a class="btn btn-default job-selector" title="select all"><i
							class="fa fa-angle-right font-weight-bold"></i></a>
					  </div>
					</div>
				  </div>
				  <mat-list role="list" class="list-height">
					<mat-selection-list disableRipple="true">
						<mat-list-option disableRipple="true" color="primary" checkboxPosition="before"
							*ngFor="let item of allItems" [value]="item">
							{{item[textField]}}
						</mat-list-option>
					</mat-selection-list>
					<!-- <mat-list-item role="listitem" checkboxPosition="before"
					*ngFor="let item of allItems" [value]="item" class="job-list">{{item[textField]}}</mat-list-item> -->
					<!-- <mat-list-item role="listitem" class="job-list">AA894525 - Test Message 1, Test Message 2, Test
					  Message 1, Test Message 2,</mat-list-item>
					<mat-list-item role="listitem" class="job-list">AA894525 - Test Message 1, Test Message 2, Test
					  Message 1, Test Message 2,</mat-list-item>
					<mat-list-item role="listitem" class="job-list">AA894525 - Test Message 1, Test Message 2, Test
					  Message 1, Test Message 2,</mat-list-item>
					<mat-list-item role="listitem" class="job-list">AA894525 - Test Message 1, Test Message 2, Test
					  Message 1, Test Message 2,</mat-list-item>
					<mat-list-item role="listitem" class="job-list">AA894525 - Test Message 1, Test Message 2, Test
					  Message 1, Test Message 2,</mat-list-item>
					<mat-list-item role="listitem" class="job-list">AA894525 - Test Message 1, Test Message 2, Test
					  Message 1, Test Message 2,</mat-list-item>
					<mat-list-item role="listitem" class="job-list">AA894525 - Test Message 1, Test Message 2, Test
					  Message 1, Test Message 2,</mat-list-item>
					<mat-list-item role="listitem" class="job-list">AA894525 - Test Message 1, Test Message 2,
					</mat-list-item>
					<mat-list-item role="listitem" class="job-list">AA894525 - Test Message 1, Test Message 2,
					</mat-list-item>
					<mat-list-item role="listitem" class="job-list">AA894525 - Test Message 1, Test Message 2,
					</mat-list-item>
					<mat-list-item role="listitem" class="job-list">AA894525 - Test Message 1, Test Message 2,
					</mat-list-item> -->
				  </mat-list>
				</div>
			  </div>
			</div>
			<div class="material-list-right  col-md-6">
			  <div class="material-cart">
				<div class="material-cart-box">
				  <div class="row">
					<div class="col-md-12">
					  <p class="ff-2 fs-14">Selected Items</p>
					</div>
					<div class="col-md-2 align-self-center">
					  <div class="btn-group">
						<a class="btn btn-default job-selector" title="select all"><i
							class="fa fa-angle-double-left font-weight-bold"></i></a>
						<a class="btn btn-default job-selector " title="select all"><i
							class="fa fa-angle-left font-weight-bold"></i></a>
					  </div>
					</div>
					<div class="col-md-10">
					  <EIPAutoComplete TextField="dedDescription" floatLabelOption="never" WaterMarkText="Search">
					  </EIPAutoComplete>
					</div>
				  </div>
				  <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event)">
					<div class="example-box" cdkDrag>
						<div class="example-custom-placeholder" *cdkDragPlaceholder></div>
						text
					</div>
					<div class="example-box" cdkDrag>
						<div class="example-custom-placeholder" *cdkDragPlaceholder></div>
						text
					</div>
				</div>
				  <!-- <mat-list role="list" class="list-height">
					<mat-list-item role="listitem" class="job-list">Item 1</mat-list-item>
					<mat-list-item role="listitem" class="job-list">Item 2</mat-list-item>
					<mat-list-item role="listitem" class="job-list">Item 3</mat-list-item>
				  </mat-list> -->
				</div>
			  </div>
			</div>
		  </div>
		</div>
	  </div>
	</div>
  </div>
  <div mat-dialog-actions>
	<div class="row justify-content-end flex-grow-1">
	  <button class="btn btn-primary" id="btnSave">Share</button>
	</div>
  </div>  